import { useCallback, useEffect, useImperativeHandle, useState, useMemo, useRef } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { i18n } from '../../language';
import { BEDSTATUS_CHOOSE_FILTER, BEDSTATUS_OUTSTANDING_TRANSFER_IN } from '../../comm/constant';
import { isRequest } from '../../utils';
import { bedStatusAPI } from '../../apis';
import { userRoleFunc } from '../../utils/userRole';
import Landing from './newComponents/Landing/index';
import Header from './newComponents/Header';
import { InternalBooking, TransferOut } from './components';
import { bsFilterFunc } from './components/BedStatusAll/filterFunc';
import bs from './bsApp';
import Admission from './components/InternalBooking/Admission';
import TransactionHistory from './newComponents/TransactionHistory';
import { BedStatusStatisticContext, BEDSTATUS_STATISTIC, bsTransferInStatisticRef } from '.';

const useStyles = makeStyles((theme) => ({
  transferBox: {
    padding: '1.25rem 3.438rem 0',
    '&>div': {
      margin: '0',
      borderRadius: '12px',
      border: 'solid 1px #e4e7eb',
    },
    '& .MuiTableContainer-root': {
      height: '32rem',
    },
  },
}));

const NewBedStatus = () => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(Number(sessionStorage.getItem('bsType')));
  const [filter, setFilter] = useState(initFilter);
  const rouList = useSelector((state) => state.rouList);
  const loginInfo = useSelector((state) => state.loginInfo);
  const userRole = useSelector((state) => state.userRole);
  const [filterData, setFilterData] = useState(null);
  const [initFulter, setInitFulter] = useState(false);
  const statisticStorage = JSON.parse(sessionStorage.getItem(BEDSTATUS_STATISTIC));
  const [statistic, setStatistic] = useState({
    pendingWardAckCount: statisticStorage?.pendingWardAckCount ?? 0,
    outstandingCount: statisticStorage?.outstandingCount ?? 0,
    eAdmOutstandingCount: statisticStorage?.eAdmOutstandingCount ?? 0,
    pendingFYACount: statisticStorage?.pendingFYACount ?? 0,
    pendingWardReadyCount: statisticStorage?.pendingWardReadyCount ?? 0,
  });
  const [refresh, setRefresh] = useState(true);
  const [showPatientName, setShowPatientName] = useState(false);
  const headerRef = useRef(null);

  const handleResetFilter = useCallback(() => {
    const filterObj = bsFilterFunc.setDefaultFilter();
    setFilterData(filterObj);
  }, []);

  const handleFilterSelectOption = useCallback((key) => {
    return () => {
      setFilterData((o) => {
        const newFilterData = bsFilterFunc.clickFilter({ allData: o, keys: key });
        return newFilterData;
      });
    };
  }, []);

  const statusBottom = [
    { typeName: bs.AVAILABLE, text: i18n.t('BEDSTATUS_VACANT'), idName: 'bed_navigation_btn17' },
    { typeName: bs.OCCUPIED, text: i18n.t('BEDSTATUS_OCCUPIED'), idName: 'bed_navigation_btn18' },
    { typeName: bs.DISCHARGING, text: i18n.t('BEDSTATUS_DISCHARGING'), idName: 'bed_navigation_btn19' },
    { typeName: bs.TBC, text: i18n.t('BEDSTATUS_TBC'), idName: 'bed_navigation_btn20' },
    { typeName: bs.UNAVAILABLE, text: i18n.t('BEDSTATUS_UNAVAILABLE'), idName: 'bed_navigation_btn21' },
  ];

  const remarks = [
    { typeName: bs.MISSING, text: i18n.t('BEDSTATUS_MISSING'), idName: 'bed_navigation_btn1' },
    { typeName: bs.MISSING_CLOSED, text: i18n.t('BEDSTATUS_MISSING_CLOSED_CASE'), idName: 'bed_navigation_btn2' },
    { typeName: bs.DAY_BED, text: i18n.t('BEDSTATUS_DAY_BED'), idName: 'bed_navigation_btn3' },
    { typeName: bs.ADDED_BED, text: i18n.t('BEDSTATUS_ADDED_BED'), idName: 'bed_navigation_btn4' },
    { typeName: bs.ATTENTION, text: i18n.t('BEDSTATUS_ATTENTION'), idName: 'bed_navigation_btn5' },
    { typeName: bs.NEATS, text: i18n.t('BEDSTATUS_NEATS'), idName: 'bed_navigation_btn6' },
    {
      typeName: bs.BASIC_CLEANSING,
      typeName2: bs.BASIC_CLEANSING_ONGOING,
      text: i18n.t('BEDSTATUS_BASIC_CLEANSING'),
      idName: 'bed_navigation_btn7',
    },
    {
      typeName: bs.TERMINAL_DISINFECTION,
      typeName2: bs.TERMINAL_DISINFECTION_ONGOING,
      text: i18n.t('BEDSTATUS_TERMINAL_DISINFECTION'),
      idName: 'bed_navigation_btn8',
    },
    {
      typeName: bs.PENDING_ADMISSION,
      typeName2: bs.RETURN_DAY_CASE,
      text: `${i18n.t('BEDSTATUS_PENDING_ADMISSION')}/${i18n.t('BEDSTATUS_RETURN_DAY_CASE')}`,
      idName: 'bed_navigation_btn9',
    },
    { typeName: bs.RESUSITATION, text: i18n.t('BEDSTATUS_RESUSITATION'), idName: 'bed_navigation_btn10' },
    { typeName: bs.MAINTANIENCE, text: i18n.t('BEDSTATUS_MAINTANIENCE'), idName: 'bed_navigation_btn11' },
    {
      typeName: bs.LIFE_SAVING_EQUIPMENT,
      text: i18n.t('BEDSTATUS_LIFE_SAVING_EQUIPMENT'),
      idName: 'bed_navigation_btn12',
    },
    { typeName: bs.AIRBORNE_PRECAUTION, text: i18n.t('BEDSTATUS_AIRBORNE_PRECAUTION'), idName: 'bed_navigation_btn13' },
    { typeName: bs.DROPLET_PRECAUTION, text: i18n.t('BEDSTATUS_DROPLET_PRECAUTION'), idName: 'bed_navigation_btn14' },
    { typeName: bs.CONTACT_PRECAUTION, text: i18n.t('BEDSTATUS_CONTACT_PRECAUTION'), idName: 'bed_navigation_btn15' },
    { typeName: bs.REVERSE_LSOLATION, text: i18n.t('BEDSTATUS_REVERSE_LSOLATION'), idName: 'bed_navigation_btn16' },
    { typeName: bs.COVID_19, text: i18n.t('BEDSTATUS_COVID_19'), idName: 'bed_navigation_btn17' },
    {
      typeName: bs.MDRO_CONTACT,
      typeName2: bs.MDRO_CONFIRMED,
      text: 'MDRO(Contact)/(Confirmed)',
      idName: 'bed_navigation_btn23',
    }, // MDRO
    { typeName: bs.CMS_ALERT, text: i18n.t('CMS_ALERT'), idName: 'bed_navigation_cms_alert' },
    { typeName: bs.HOME_LEAVE, text: i18n.t('BEDSTATUS_HOME_LEAVE'), idName: 'bed_navigation_btn18' },
    {
      typeName: bs.HOME_LEAVE_OVERTIME,
      text: i18n.t('BEDSTATUS_HOME_LEAVE_OVERTIME'),
      idName: 'bed_navigation_btn19',
    },
    {
      typeName: bs.TO,
      text: i18n.t('BEDSTATUS_TRANSFER_OUT'),
      idName: 'bed_navigation_btn20',
    },
    { typeName: bs.FROZEN, text: 'Frozen', idName: 'bed_navigation_btn22' },
    { typeName: bs.ELDERLY_HOME, text: i18n.t('ELDERLY_HOME'), idName: 'bed_navigation_elderly_home' },
  ];

  useEffect(() => {
    if (filterData) {
      setInitFulter(true);
      sessionStorage.setItem(BEDSTATUS_CHOOSE_FILTER, JSON.stringify(filterData));
    } else {
      const session = sessionStorage.getItem(BEDSTATUS_CHOOSE_FILTER);
      if (session) {
        const obj = JSON.parse(session);
        setFilterData(obj);
      } else {
        const filterObj = bsFilterFunc.setDefaultFilter();

        setFilterData(filterObj);
      }
    }
  }, [filterData]);

  useEffect(() => {
    if (isRequest(loginInfo, userRole) && initFulter) {
      setFilterData(null);
      sessionStorage.removeItem(BEDSTATUS_CHOOSE_FILTER);
    }
  }, [rouList, loginInfo, userRole]);

  const handleRouteToTransferIn = useCallback(
    (status) => () => {
      setSelectedTab(1);
      sessionStorage.setItem('bsType', 1);
      sessionStorage.setItem(
        BEDSTATUS_OUTSTANDING_TRANSFER_IN,
        JSON.stringify({
          startTime: '2021-01-01 00:00:00',
          stopTime: moment().add(6, 'days').format('yyyy-MM-DD 23:59:59'),
          status,
        })
      );
    },
    []
  );

  const getTransferStatistic = async () => {
    try {
      const { result } = await bedStatusAPI.getTransferStatistic();
      setStatistic(result);
      sessionStorage.setItem(BEDSTATUS_STATISTIC, JSON.stringify(result));
    } catch (error) {
      console.log(error);
    }
  };

  useImperativeHandle(bsTransferInStatisticRef, () => ({
    getTransferStatistic,
  }));

  useEffect(() => {
    // 如果在当前页面切换了用户或者角色，且没有权限访问admission，则显示回bed status的tab
    const hasAdmissionPermission = userRoleFunc?.getIsShowAdmission();
    if (!hasAdmissionPermission && [1, 2, 3].includes(selectedTab)) {
      setSelectedTab(0);
      sessionStorage.setItem('bsType', 0);
    }

    getTransferStatistic();
  }, [loginInfo]);

  // logout的时候bed status的不显示每间床的病人名称
  useEffect(() => {
    if (!loginInfo?.flag) {
      setShowPatientName(false);
    }
  }, [loginInfo?.flag]);

  useEffect(() => {
    // 3分钟之后退出显示名字的模式
    let timmer = null;
    if (showPatientName) {
      timmer = setTimeout(() => setShowPatientName(false), [3 * 60 * 1000]);
    }
    return () => clearTimeout(timmer);
  }, [showPatientName]);

  const value = useMemo(() => ({ statistic, refresh, setRefresh }), [statistic, refresh, setRefresh]);

  return (
    <BedStatusStatisticContext.Provider value={value}>
      <Box display="flex" flexDirection="column">
        <Header
          ref={headerRef}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          filter={filter}
          setFilter={setFilter}
          filterData={filterData}
          setFilterData={setFilterData}
          handleResetFilter={handleResetFilter}
          statusBottom={statusBottom}
          remarks={remarks}
          showPatientName={showPatientName}
          setShowPatientName={setShowPatientName}
        />
        {selectedTab === 0 && (
          <Landing
            headerRef={headerRef}
            filter={filter}
            handleFilterSelectOption={handleFilterSelectOption}
            statusBottom={statusBottom}
            remarks={remarks}
            filterData={filterData}
            handleRouteToTransferIn={handleRouteToTransferIn}
            showPatientName={showPatientName}
          />
        )}
        {selectedTab === 1 && (
          <Box className={classes.transferBox}>
            <InternalBooking />
          </Box>
        )}
        {selectedTab === 2 && (
          <Box className={classes.transferBox}>
            <TransferOut />
          </Box>
        )}
        {selectedTab === 3 && (
          <Box className={classes.transferBox}>
            <Admission />
          </Box>
        )}
        {selectedTab === 4 && <TransactionHistory />}
      </Box>
    </BedStatusStatisticContext.Provider>
  );
};

const initFilter = () => {
  const SSO_WARD_LOCATION = sessionStorage.getItem('SSO_WARD_LOCATION');

  return {
    wardLocation: SSO_WARD_LOCATION ? SSO_WARD_LOCATION : 'All',
  };
};

export default NewBedStatus;
